import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { DocumentsConsultModel } from '../../models/consult/documents-consult.model';
import { DocumentsResponseEntity } from '../../../data/repositories/consult/entities/documents-response.entity';

export class UpdateDocumentsUseCase implements UseCase<DocumentsConsultModel[], DocumentsResponseEntity> {
    constructor(private document: ConsultRepository) { }
    execute(
        params: DocumentsConsultModel[],
    ): Observable<DocumentsResponseEntity> {
        return this.document.updateDocuments(params);
    }
}
